import { ActionColumnFormat } from './ColumnsFormatters/ActionColumnFormat';
import { StatusColumnFormat } from './ColumnsFormatters/StatusColumnFormat';

export const columns = (onEye, onDelete, onRepeat, disableBoton) => [
	{
		dataField: 'usuario',
		text: 'Clave',
		classes: ' text-center',
	},
	{
		dataField: 'nombre',
		text: 'Nombre',
		classes: ' text-center',
	},
	{
		dataField: 'apellidoPaterno',
		text: 'Apellido Paterno',
		classes: ' text-center',
	},
	{
		dataField: 'apellidoMaterno',
		text: 'Apellido Materno',
		classes: ' text-center',
	},
	{
		dataField: 'fechaCreacion',
		text: 'Fecha de Alta',
		classes: ' text-center',
	},
	{
		dataField: 'fechaUltimoAcceso',
		text: 'Fecha de Ultimo Ingreso',
		classes: ' text-center',
	},
	{
		dataField: 'estatus',
		text: 'Estatus',
		classes: ' text-center',
		formatter: StatusColumnFormat,
	},
	{
		dataField: 'id',
		text: 'Acciones',
		classes: 'text-center',
		headerClasses: 'text-center',
		style: { minWidth: '137px' },
		formatter: ActionColumnFormat,
		formatExtraData: {
			onRepeat,
			onEye,
			onDelete,
			disableBoton,
		},
	},
];

export const defaultFilter = {
	status: '',
	start_date: null,
	end_date: null,
	predictiveName: '',
	predictiveUser: '',
};

export const filterForm = (onConfirmFilter, onClear, onSearch) => [
	{
		label: 'Estatus',
		name: 'status',
		type: 'chip-dropdown',
		options: [
			{ value: 'A', text: 'Activo', color: 'success' },
			{ value: 'I', text: 'Inactivo', color: 'danger' },
			{ value: 'B', text: 'Baja', color: 'danger' },
		],
		column: 3,
	},
	{
		label: 'Fecha de Inicio',
		name: 'start_date',
		type: 'date',
		column: 3,
	},
	{
		label: 'Fecha de Fin',
		name: 'end_date',
		type: 'date',
		column: 3,
	},
	{
		label: 'Buscar',
		name: 'Buscar',
		color: 'light-primary',
		type: 'button',
		column: 1,
		onClick: onConfirmFilter,
		style: { display: 'flex' },
	},
	{
		label: 'Limpiar',
		name: 'Limpiar',
		color: 'light-warning',
		type: 'button',
		onClick: onClear,
		column: 1,
		style: { display: 'flex', margin: '0px 0px 0px 5px' },
	},
	{
		label: 'Nombre de Usuario',
		placeholder: 'Introduce Nombre de Usuario',
		name: 'predictiveName',
		type: 'text',
		column: 3,
	},
	{
		label: 'Buscar Nombre de Usuario',
		name: 'Buscar',
		color: 'light-primary',
		type: 'button',
		column: 3,
		onClick: onSearch,
		style: { width: '100%' },
	},
	{
		label: 'Clave de Usuario',
		placeholder: 'Introduce Clave de Usuario ',
		name: 'predictiveUser',
		type: 'text',
		column: 3,
	},
	{
		label: 'Buscar Clave de Usuario',
		name: 'Buscar',
		color: 'light-primary',
		type: 'button',
		column: 3,
		onClick: onSearch,
		style: { width: '100%' },
	},
];
